export const SET_HEADER_BUTTONS = 'SET_HEADER_BUTTONS';
export const PUSH_HEADER_BUTTON = 'PUSH_HEADER_BUTTON';
export const POP_HEADER_BUTTON  = 'POP_HEADER_BUTTON';